"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["unit", "className", "id", "name", "label", "right", "left"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function formatNumber(n) {
  // format number 1000000 to 1,234,567
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); // NOSONAR
}
function formatUnit(rawValue) {
  var value = rawValue.replace(/[^0-9\.]/g, '');
  if (value) {
    var decimalPos = value.indexOf('.');
    if (decimalPos > -1) {
      var integers = value.substring(0, decimalPos);
      var allDecimals = value.substring(decimalPos + 1);
      var decimals = allDecimals.substring(0, 1);
      return {
        mask: "".concat(formatNumber(integers), ".").concat(formatNumber(decimals)),
        value: "".concat(integers, ".").concat(decimals)
      };
    }
    return {
      mask: "".concat(formatNumber(value)),
      value: value
    };
  }
  return {
    mask: '',
    value: ''
  };
}
function UnitInput(props) {
  var unit = props.unit,
    className = props.className,
    id = props.id,
    name = props.name,
    label = props.label,
    right = props.right,
    left = props.left,
    rest = _objectWithoutProperties(props, _excluded);
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var error = meta.error,
    touched = meta.touched;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    mask = _useState2[0],
    setMask = _useState2[1];
  var hasError = touched && error;
  var icn = (0, _classnames["default"])('form-control', hasError && 'is-invalid', right && 'input-group-br-no', left && 'input-group-bl-no');
  (0, _react.useEffect)(function () {
    if (field.value) {
      var _formatUnit = formatUnit(String(field.value)),
        _mask = _formatUnit.mask;
      setMask(_mask);
    }
  }, []);
  var handleChange = (0, _react.useCallback)(function (e) {
    var target = e.target;
    var _formatUnit2 = formatUnit(target.value),
      mask = _formatUnit2.mask,
      value = _formatUnit2.value;
    helpers.setValue(value);
    setMask(mask);
  }, []);
  var handleBlur = (0, _react.useCallback)(function (e) {
    var target = e.target;
    var _formatUnit3 = formatUnit(target.value),
      mask = _formatUnit3.mask,
      value = _formatUnit3.value;
    helpers.setTouched(true);
    helpers.setValue(value);
    setMask(mask);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(className || '', " ")
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('col-form-label', hasError && error && 'text-danger'),
    htmlFor: id
  }, hasError || label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: icn
  }, field, {
    onBlur: handleBlur,
    id: id,
    onChange: handleChange,
    value: typeof mask === 'undefined' ? field.value : mask
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "input-group-text"
  }, unit))));
}
UnitInput.propTypes = {
  unit: _propTypes["default"].string
};
UnitInput.defaultProps = {
  unit: 'cm'
};
var _default = exports["default"] = UnitInput;